/* eslint-disable no-console */

module.exports = {
  locales: ["en", "tr"],
  defaultLocale: "tr",
  localeDetection: false,
  pages: {
    "*": [
      "common",
      "routes",
      "header",
      "validations",
      "bank",
      "accounts",
      "money-transfer",
      "shared",
    ],
    "/": ["home", "confirm-cancel-process", "money-transfer"],
    "rgx:^/login/*": ["login"],
    "rgx:^/register/*": ["signup", "login"],
    "rgx:^/dashboard/*": ["dashboard"],
    "rgx:^/profile/*": ["profile"],
    "rgx:^/money-transfer/*": ["money-transfer"],
    "rgx:^/confirm-cancel-process/*": ["confirm-cancel-process", "home", "money-transfer"],
    "rgx:^/iban-verification/*": ["iban-verification"],
    "rgx:^/where-money/*": ["where-money"],
  },
  loadLocaleFrom: async (locale, namespace) => {
    const retries = 3;

    const loadLanguage = async (retryCount) => {
      try {
        const m = await import(`./src/translations/${locale}/${namespace}.ts`);
        return m.default || m;
      } catch (error) {
        if (retryCount < retries - 1) {
          console.error(
            `Dil dosyası ${locale}/${namespace} yüklenemedi, tekrar deneme: ${retryCount + 1}`,
            error
          );
          return loadLanguage(retryCount + 1);
        }
        throw new Error(`Dil dosyası ${locale}/${namespace} yüklenemedi: ${error.message}`);
      }
    };

    return loadLanguage(0);
  },
};
